export const scaleFontSize = (value: string, factor: number): string =>
  value.replace(/(-?\d*\.?\d+)(rem|em|px|vw)/g, (_, numericValue: string, unit: string) => {
    const scaledValue = Number.parseFloat(numericValue) * factor;
    return `${scaledValue}${unit}`;
  });
